module.exports = __webpack_public_path__ + "img/customer_design_6@2x.ea777b6.webp";